export default "__VITE_ASSET__D4aAOVmF__"